import React, {
	CSSProperties,
	ForwardedRef,
	forwardRef,
	ReactElement,
	ReactNode
} from 'react';
import { LeafletPosition } from '../../../utils';

import './map-control-container.styles.scss';

export interface IMapControlContainerProps {
	position: LeafletPosition;
	className?: string;
	children?: ReactNode;
	style?: CSSProperties;
}

function MapControlContainerView(
	props: IMapControlContainerProps,
	ref: ForwardedRef<HTMLDivElement>
): ReactElement {
	const { position, className, children, style } = props;

	return (
		<div
			style={style}
			ref={ref}
			className={`map-control-container ${position} ${className || ''}`}
		>
			{children}
		</div>
	);
}

export const MapControlContainer = forwardRef<
	HTMLDivElement,
	IMapControlContainerProps
>(MapControlContainerView);
